import axios from 'axios';
import store from 'src/redux/store';
import { HTTP_METHODS } from './helpers/methods-helpers';
import { encryptGlobal, generateIv, decryptGlobal } from './helpers/encrypt-decrypt';
const { Service } = require('axios-middleware');

export default class API {
	initialURL = '';
	scheme = '';
	request = null;
	constructor(scheme = '', initialURL = process.env.REACT_APP_API_URL) {
		this.initialURL = initialURL;
		this.scheme = scheme;
		this.request = axios.create({
			baseURL: this.initialURL,
			headers: {
				'Content-Type': 'text/plain',
			},
		});

		const service = new Service(this.request);
		this.request.interceptors.request.use(
			(response) => {
				//console.log('Request', response.data, response.url);
				const protectedRoutes = ['/login/out'];

				const shouldEncrypt =
					response.url &&
					protectedRoutes.some((route) => response.url.startsWith(route));

				if (!shouldEncrypt && response.data) {
					//if (response.data) {
					const iv = generateIv();
					const payload = encryptGlobal(response.data, iv);
					response.data = { iv, payload };
				}

				return response;
			},
			(error) => Promise.reject(error)
		);

		this.request.interceptors.response.use(
			(response) => {
				const url = response.config.url ?? '';
				//console.log('Response cifrado', response.data);

				// const decryptRoutes = [
				// 	'/ordenDia',
				// 	'/bitacora-accion',
				// 	'/inclusion_temas',
				// 	'/asistencia',
				// 	'/archivos',
				// ];

				// const isDecryptable = decryptRoutes.some((route) =>
				// 	url.startsWith(route)
				// );

				if (
					//isDecryptable &&
					response.data &&
					response.data.payload &&
					response.data.iv
				) {
					try {
						const decrypted = decryptGlobal(
							response.data.payload,
							response.data.iv
						);
						response.data = decrypted;
						//console.log(response.data);
						console.log('Response decifrado', response.config.url, decrypted);
					} catch (err) {
						console.error(err);
					}
				}

				return response;
			},
			(error) => Promise.reject(error)
		);

		service.register({
			onRequest(config) {
				let dataJson = {};

				if (config.data !== undefined) {
					dataJson = JSON.parse(config.data);
				}
				const configFlag = { ...config };
				if (configFlag?.headers?.Authorization) {
					return configFlag;
				} else {
					const token = store.getState()?.auth?.user?.accessToken;
					//const perfil = store.getState()?.organos?.organo?.nombrePerfil;
					if (token) {
						configFlag.headers = {
							//perfil: perfil,
							...configFlag.headers,
							//Authorization: `${token}`,
						};

						dataJson = { ...dataJson, token: token };
					}
				}

				configFlag.data = JSON.stringify(dataJson);
				return configFlag;
			},
			onResponse(response) {
				return response;
			},
		});
	}

	requestWrapper(req) {
		return req
			.then(({ data }) => {
				try {
					if (data.err) {
						throw Error(data.err);
					}
					return data;
				} catch (error) {
					throw error;
				}
			})
			.catch((err) => {
				//We need to put in this section the logic when the token has been expired\
				throw err;
			});
	}

	get(path, params, pagination, currentPage) {
		const paginationUrl = pagination
			? `&registrosPorPagina=${pagination}&numeroDePagina=${currentPage}`
			: '';

		const url = path ? `${this.scheme}/${path}${paginationUrl}` : this.scheme;
		return this.requestWrapper(
			this.request({ url, data: params, method: HTTP_METHODS.post_M })
		);
	}

	post(data, path) {
		const url = path ? `${this.scheme}/${path}` : this.scheme;
		const dataString = JSON.stringify(data);
		return this.requestWrapper(
			this.request({ url, data: dataString, method: HTTP_METHODS.post_M })
		);
	}

	put(id, data) {
		const url = id ? `${this.scheme}/put/${id}` : this.scheme;
		const dataString = JSON.stringify(data);
		return this.requestWrapper(
			this.request({ url, data: dataString, method: HTTP_METHODS.post_M })
		);
	}

	patch(id, data) {
		const url = id ? `${this.scheme}/${id}` : this.scheme;
		const dataString = JSON.stringify(data);
		return this.requestWrapper(
			this.request({ url, data: dataString, method: 'PATCH' })
		);
	}

	delete(id, data = {}) {
		const dataString = JSON.stringify(data);
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/delete/${id}`,
				data: dataString,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	show(id, params) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/${id}`,
				params,
				method: HTTP_METHODS.post_M,
			})
		);
	}
}

export const baseRequest = new API('/');
